"use client";

import { NavLink } from "react-router";
import classnames from "classnames";

import styles from "./bottom-nav.module.scss";

export interface BottomNavItem {
  to: string;
  label: string;
  icon: React.ReactNode;
}

export interface BottomNavProps {
  items: BottomNavItem[];
  /** Breakpoint at which to hide. Default: "tablet" (768px). */
  hideAbove?: "tablet" | "desktop";
  "aria-label"?: string;
}

export function BottomNav({
  items,
  hideAbove = "tablet",
  "aria-label": ariaLabel = "Main navigation",
}: BottomNavProps) {
  return (
    <nav className={styles.nav} data-hide={hideAbove} aria-label={ariaLabel}>
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => classnames(styles.item, isActive && styles.active)}
        >
          <span className={styles.icon}>{item.icon}</span>
          <span className={styles.label}>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
